import { FunctionComponent } from "react";
import { Section } from "@Types/pagify";
import "./style.scss";

export const ProductHeader: FunctionComponent<{
  section: Section;
}> = ({ section }) => {
  return (
    <div className="ProductHeader">
      <h1 className="ProductHeader-title">{section.title}</h1>
      <div className="ProductHeader-subtitle">
        {section.subtitle.map((textBlock) => {
          return <span key={textBlock.text}>{textBlock.text}</span>;
        })}
      </div>
    </div>
  );
};
